/**
 * The client's entry point.
 */

import { Auth0Provider } from '@auth0/auth0-react'; // for SSO
import { fromJS } from 'immutable';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import { init } from './actions/global';
import { createRootReducer } from './reducers';
import { getRoutes } from './routes';
import { applyHighchartsDefaults } from './utils/highchartsDefaults';

applyHighchartsDefaults();

const auth0Config = {
  domain: 'login.trueprodigyapps.com',
  clientId: 'ELLxeadiAkmKJ9BhEKioFNGw1Sp1yDNF',
  authorizationParams: {
    audience: 'https://dev-wrmdvblhk07q5tkj.us.auth0.com/api/v2/',
    redirect_uri: window.location.origin,
  },
  cacheLocation: 'localstorage', // auth0 sessions were not registered by useAuth0 hook without this
};

// Enable react devtool support during development
if (process.env.NODE_ENV !== 'production') {
  // For dev tool support, attach to window...
  window.React = React;
}

export function createOurStore(reducers, initialState) {
  const composeEnhancers =
    (__DEVELOPMENT__ &&
      typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
  return createStore(
    reducers,
    initialState,
    composeEnhancers(applyMiddleware(thunk)),
  );
}

async function boot() {
  // Create redux store
  const initialState = fromJS({});
  const store = createOurStore(createRootReducer(), initialState);

  await store.dispatch(init());
  // Render application
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <Auth0Provider {...auth0Config}>
        <ReduxProvider store={store}>
          <BrowserRouter>{getRoutes(store)}</BrowserRouter>
        </ReduxProvider>
      </Auth0Provider>
    </StrictMode>,
  );
}

boot();
